import React, {
  Component
} from 'react';
import ReactCountdownClock from 'react-countdown-clock';

export default class TimerCountDown extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  onComplete(){
    this.props.onComplete();
  }

  render() {

   const {seconds}=this.props;

   let timerStyle={
    position:'fixed',
    right:0,
    top:'6px',
    padding:'7px',
    zIndex:198,
    background:'#fff'
   }

    return (
     <div className="timerCountDown" style={timerStyle}>

     <ReactCountdownClock seconds={seconds}
                  showMilliseconds={true}
                  color="#D24D57"
                  alpha={0.9}
                  size={80}
                  onComplete={(e)=>this.onComplete()} />

     </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/TimerCountDown.js